import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";
import { CONTACT } from "../lib/translations";

const ACCENTS = ["bg-dustyrose", "bg-champagne-deep", "bg-olive", "bg-warmbrown-soft"];

export default function Services() {
  const { t } = useLanguage();
  const waLink = (label) => `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(`Hola Amaranto, me interesa ${label}.`)}`;

  return (
    <section id="services" data-testid="services-section" className="bg-cream paper-grain py-28 md:py-36">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid md:grid-cols-12 gap-6 items-end mb-14">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-px bg-warmbrown" />
              <span className="eyebrow">{t.services.eyebrow}</span>
            </div>
            <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-ink">
              {t.services.title}
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="font-body italic text-ink-soft max-w-md">{t.services.sub}</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-cream-300 border border-cream-300">
          {t.services.items.map((s, i) => (
            <motion.div
              key={s.tag}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.9, delay: i * 0.08 }}
              className="bg-paper p-8 md:p-12 group relative overflow-hidden"
              data-testid={`service-card-${i + 1}`}
            >
              <div className={`absolute top-0 left-0 h-px w-16 ${ACCENTS[i]} transition-all duration-700 group-hover:w-32`} />
              <div className="flex items-start justify-between mb-8">
                <span className="eyebrow text-warmbrown">{s.tag}</span>
                <span className={`w-3 h-3 rounded-full ${ACCENTS[i]} opacity-80`} aria-hidden />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-ink leading-tight">{s.name}</h3>
              <p className="font-body text-sm md:text-base text-ink-soft mt-5 leading-relaxed max-w-md">{s.body}</p>

              <a
                href={i === 1 ? "#corporate" : i === 2 ? "#craft" : i === 3 ? "#corporate" : waLink(s.name)}
                target={i === 0 ? "_blank" : undefined}
                rel="noreferrer"
                data-testid={`service-cta-${i + 1}`}
                className="inline-flex items-center gap-3 mt-10 text-[11px] tracking-[0.3em] uppercase font-semibold border-b border-ink pb-1 text-ink hover:text-warmbrown hover:border-warmbrown transition-colors duration-500"
              >
                {s.cta} →
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
